import { api } from './client'

// Runtime feature flags fetched from the backend so an env-var flip on
// Render takes effect on the next page load — no frontend redeploy. The
// endpoint is unauthenticated; the values are non-sensitive and the
// check-in screen needs them before any auth context is wired up.
export const featureFlagsApi = {
  get: () => api.get('/feature-flags'),
}
